<style lang="less" scoped>
    .active {
        background-color: #ff551b;
    }

    .right_side {
        position: fixed;
        z-index: 22;
        top: 400px;
        right: 0px;
        width: 70px;
        /*background-color: #fff;*/
        border-radius: 10px;
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
        .side_item {
            text-align: center;
            height: 66px;
            line-height: 85px;
            border-bottom: 2px solid #f2f2f2;
            cursor: pointer;
            .icon {
                width: 26px;
                height: 26px;
            }
        }
        .side_item:nth-child(1) {
            border-radius: 10px 10px 0 0;
        }
        .side_item:nth-child(4) {
            border: none;
            border-radius: 0 0 10px 10px;
        }
        .ask {
            position: absolute;
            left: 0px;
            top: 0px;
            width: 80px;
            line-height: 25px;
            padding: 15px 0px;
            height: 50px;
            background-color: #b4a078;
            font-family: "微软雅黑";
            font-size: 20px;
            color: #fff;
            border-bottom: solid 1px #b4a078;
            display: none;
        }
        .WX {
            position: absolute;
            top: 135px;
            left: -180px;
            width: 190px;
            height: 70px;
            background: url("../../assets/img/side/bg_1_3.png");
            background-size: 100%;
            font-size: 12px;
            color: #666;
            text-align: center;
            line-height: 70px;
            padding-right: 10px;
            box-sizing: border-box;
        }
        .KF {
            position: absolute;
            top: 135px;
            left: -180px;
            width: 190px;
            height: 70px;
            background: url("../../assets/img/side/bg_1_3.png");
            background-size: 100%;
            font-size: 12px;
            color: #666;
            text-align: center;
            line-height: 70px;
            padding-right: 10px;
            box-sizing: border-box;
        }

    }
</style>
<template>
    <div class="right_side">
        <!-- qq -->
        <div
                class="side_item"
                v-for="(item, index) in sideList"
                :key="index"
                :class="{ active: active == index }"
                @mouseenter="active = index"
                @mouseleave="active = -1"
                @click="go(index)"
        >
            <img v-if="active == index" class="icon" :src="item.img2" alt=""/>
            <img v-else :src="item.img1" class="icon" alt=""/>
        </div>
        <div class="WX" v-if="active == 0">
            <div>
                "问卷调查"
            </div>
        </div>
        <div class="WX" v-if="active == 1">
            <div>{{869075703}}</div>
        </div>
<!--        <div class="KF" v-if="active == 2">客服热线：{{13203855872}}</div>-->
<!--        <div class="KF" v-if="active == 2"></div>-->
        <!-- <div class="WX APP" v-if="active == 3">
          <img src="../../assets/img/home/code.png" alt="" />
          <div>任性学习就靠它</div>
        </div> -->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                infoList: {},
                active: -1,
                scrollTop: "",
                sideList: [
                    {
                        img1: require("../../assets/img/side/ask.png"),
                        img2: require("../../assets/img/side/ask.png"),

                    },
                    {
                        img1: require("../../assets/img/side/icon_qq.png"),
                        img2: require("../../assets/img/side/icon_qq2.png"),
                    },
                    {
                        img1: require("../../assets/img/side/icon_kefu.png"),
                        img2: require("../../assets/img/side/icon_kefu2.png"),
                    },
                    // {
                    //   img1: require("../../assets/img/side/icon_app.png"),
                    //   img2: require("../../assets/img/side/icon_app2.png"),
                    // },
                    {
                        img1: require("../../assets/img/side/icon_top.png"),
                        img2: require("../../assets/img/side/icon_top2.png"),
                    },
                ],
            };
        },
        mounted() {
            window.addEventListener("scroll", this.handleScroll);
        },
        destroyed() {
            document.removeEventListener("scroll", this.handleScroll);
        },
        methods: {

            handleScroll() {
                const that = this;
                let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                that.scrollTop = scrollTop;
            },
            go(i) {

                if (i == 0) {

                    this.$router.push({
                        path: "/questionnaire"
                    });
                }
                if (i == 1) {
                    let href = `http://wpa.qq.com/msgrd?v=3&uin=${858002201}&site=qq&menu=yes`;
                    window.open(href, "_blank");
                }
                if (i == 3) {
                    this.goTop();
                }
            },
            // 回到顶部
            goTop() {
                // window.scroll(0,0);
                const that = this;
                let timer = setInterval(() => {
                    let ispeed = Math.floor(-that.scrollTop / 10);
                    document.documentElement.scrollTop = document.body.scrollTop =
                        that.scrollTop + ispeed;
                    if (that.scrollTop === 0) {
                        clearInterval(timer);
                    }
                }, 10);
            },
        },
    };
</script>
